// Session SC2B: the ONE pager for a list the server pages (Previous / Next with "Showing 1 to 50 of 640"). Extracted from the Email engine
// page, where it was written first, so every paged list reads and behaves the same way. The total is the SERVER's count of everything that
// matches, never the length of the page; a list that fits one page and starts at the top shows only its count.
export interface PagerProps {
  offset: number;
  /** The true total of matching records, from the server. */
  total: number;
  /** How many records this page holds. */
  shown: number;
  pageSize: number;
  onOffset: (offset: number) => void;
  /** Singular and plural of what is listed, for the one-page line. Default record / records. */
  noun?: readonly [string, string];
}

export function Pager({ offset, total, shown, pageSize, onOffset, noun = ["record", "records"] }: PagerProps) {
  if (total <= pageSize && offset === 0) {
    return (
      <p className="mt-2 text-xs text-ele-body">
        {total} {total === 1 ? noun[0] : noun[1]}
      </p>
    );
  }
  return (
    <div className="mt-2 flex items-center justify-between text-xs text-ele-body">
      <span>
        Showing {total === 0 ? 0 : offset + 1} to {offset + shown} of {total}
      </span>
      <div className="flex gap-4">
        <button type="button" disabled={offset === 0} onClick={() => onOffset(Math.max(0, offset - pageSize))} className="font-menu text-xs tracking-wide disabled:opacity-40 max-sm:min-h-11">
          Previous
        </button>
        <button type="button" disabled={offset + pageSize >= total} onClick={() => onOffset(offset + pageSize)} className="font-menu text-xs tracking-wide disabled:opacity-40 max-sm:min-h-11">
          Next
        </button>
      </div>
    </div>
  );
}
